import { Product, scaleImage } from '@news-mono/web-common'
import React, { Fragment, useEffect, useState } from 'react'
import { mapListVideo } from 'web-common/src/__api-mapping/v4/list-video'
import { Skeleton, useProduct } from '../..'
import { ShareIcon } from '../../SevenNewsV2/HeroCard/ArticleHeroCard/assets/ShareIcon'
import { Share } from '../../SevenNewsV2/HeroCard/Share/Share'
import { useViewport } from '../../__helpers/use-viewport'
import { StyledVideo, videoClassname } from '../../content/Video/Video.styled'
import { PlayOverlay } from '../../content/Video/components/PlayOverlay/PlayOverlay'
import { TitleOverlay } from '../../content/Video/components/TitleOverlay/TitleOverlay'
import { UnmuteButton } from '../../content/Video/components/UnmuteButton/UnmuteButton'
import { RenderPlayerParams } from '../../content/Video/player-render-params'
import { getHumanDuration } from '../../content/Video/utils/get-human-duration'
import { ByLine } from '../../SevenNewsV2/HeroCard/ByLine/ByLine'
import { getPosterImage } from '../../content/Video/utils/poster'
import { getImageWidth } from '../../content/Video/utils/product-info'
import { Carousel } from '../Carousel/Carousel'
import { StyledVideoPlayerWrapper } from '../VideoPlayer/VideoPlayer.styled'
import { SevenVideoDescription } from './VideoDescription'
import {
    StyledBylineWrap,
    StyledDivider,
    StyledPlayerCarouselWrapper,
    StyledShareIconWrapper,
    StyledShareWrapper,
    StyledVideoInfoAndAdWrapper,
    StyledVideoPlayerAdContainer,
    StyledVideoPlayerHeadline,
    StyledVideoPlayerInfoContainer,
    StyledVideoPlayerInfoContainerHeader,
    StyledWrapper,
} from './VideoHubVideoSkinV2.styled'
export const videoWrapperClassName = 'video-wrapper'

export const VideoHubVideoSkinV2: React.FC<RenderPlayerParams> = ({
    theme,
    wrapperElProps,
    videoElement,
    playlistProps,
    playerState,
    playerOptions,
    playerActions,
    hideSticky,
    publicUrl,
    isLoading,
    adElement,
    withH1,
}) => {
    const [isShowMore, setIsShowMore] = useState(true)
    const [showSharePopup, setShowSharePopup] = useState(false)
    const { isTabletOrMobile } = useViewport()
    const product = useProduct()
    //prevent displaying full description on video change
    useEffect(() => {
        setIsShowMore(true)
    }, [playerState.currentVideo])

    // if devices is mobile(autoplay disabled) AND has an interal play button AND has no play button text
    // AND is on sevennews
    const showVideoTitle =
        !playerState.canAutoplay &&
        playerState.showInternalPlayButton &&
        !playerOptions.playButtonText &&
        theme.kind === Product.SevenNews

    const handleShare = async () => {
        if (isTabletOrMobile) {
            if (navigator && typeof navigator.share !== 'undefined') {
                try {
                    // TODO fix this
                    await navigator.share({
                        url: publicUrl,
                        text: 'test',
                    })
                    setShowSharePopup(false)
                } catch (e) {
                    setShowSharePopup(false)
                    console.error(e, 'Error while sharing')
                }
            } else {
                setShowSharePopup((prev) => !prev)
            }
        } else {
            setShowSharePopup((prev) => !prev)
        }
    }
    const renderUnmuteButton = playerState.isMuted &&
        !playerState.showTitleOverlay &&
        (theme.kind === Product.SevenNews
            ? true
            : !playerState.showInternalPlayButton) && (
            <UnmuteButton
                positionState={{
                    alignToTop: playerOptions.compactMode,
                    isLowered:
                        theme.kind === Product.SevenNews
                            ? false
                            : (!playerState.showTopBar &&
                                  playerState.adPlayed) ||
                              (!playerState.showTopBar &&
                                  playerState.adPlaying),
                }}
                action={playerActions.handleMuteToggle}
            />
        )

    const renderPlayOverlay = !playerState.showInternalPlayButton ? (
        false
    ) : (
        <PlayOverlay
            play={playerActions.playVideo}
            isCentered={true}
            isSmall={playerOptions.smallPlayButton}
        />
    )

    const renderTitleOverlay = (showVideoTitle ||
        playerState.showTitleOverlay) && (
        <TitleOverlay
            showVideoTitle={showVideoTitle}
            play={playerActions.playVideo}
            cancelAutoplay={playerActions.stopAutoplay}
            videoDuration={
                playerState.currentVideoMetadata
                    ? getHumanDuration(
                          playerState.currentVideoMetadata.duration,
                      )
                    : undefined
            }
            compactMode={playerOptions.compactMode || false}
            videoDetails={playerState.currentVideo}
            autoplayRemainingTime={
                playerState.currentState.type === 'autoplay-countdown'
                    ? playerState.currentState.remainingTime
                    : undefined
            }
        />
    )

    const { innerRef, ...StyledVideoWrapperProps } = wrapperElProps
    const posterImageCrop = getPosterImage(playerState.currentVideo)
    let posterImageScaled: string | undefined

    if (posterImageCrop) {
        posterImageScaled = scaleImage(
            posterImageCrop.reference,
            getImageWidth(theme.kind),
            false,
        )
    }

    if (playlistProps && playerState.currentVideoMetadata) {
        const currentVideoItem = mapListVideo(
            playerState.currentVideoMetadata,
            { publicUrl: publicUrl ?? '' },
        )

        return (
            <Fragment>
                {posterImageScaled && (
                    <style
                        dangerouslySetInnerHTML={{
                            __html: `
                                @media print {
                                    .${videoClassname}::before {
                                        content: url("${posterImageScaled}");
                                        max-width: 600px;
                                    }
                                }`,
                        }}
                    />
                )}
                <StyledWrapper
                    className={videoWrapperClassName}
                    compactMode={playerOptions.compactMode}
                    hide={hideSticky && playerOptions.compactMode}
                    isShowMore={isShowMore}
                    isVideoHub={true}
                >
                    <StyledPlayerCarouselWrapper>
                        <StyledVideoPlayerWrapper isSevenNewsV2={true}>
                            {isLoading ? (
                                <Skeleton />
                            ) : (
                                <>
                                    <StyledVideo
                                        {...StyledVideoWrapperProps}
                                        ref={innerRef}
                                        posterImage={posterImageScaled}
                                    >
                                        {renderPlayOverlay}
                                        {renderTitleOverlay}
                                        {videoElement}
                                        {renderUnmuteButton}
                                    </StyledVideo>
                                </>
                            )}
                        </StyledVideoPlayerWrapper>

                        {playlistProps &&
                            playlistProps.initialVideoMetadata &&
                            playerState.currentVideoMetadata && (
                                <Carousel
                                    onEvent={() => {}}
                                    itemMeta={
                                        playlistProps.videoQueue.items
                                            ? playlistProps.videoQueue.items
                                            : []
                                    }
                                    currentVideo={currentVideoItem}
                                    currentPath={'/'}
                                    onSelect={
                                        playlistProps.handlePlaylistSelect
                                    }
                                    isLoading={isLoading}
                                    isSevenNewsV2={true}
                                />
                            )}
                    </StyledPlayerCarouselWrapper>
                </StyledWrapper>
                <StyledVideoInfoAndAdWrapper
                    style={
                        product !== Product.SevenNews
                            ? {}
                            : { marginBottom: 16 }
                    }
                >
                    <StyledVideoPlayerInfoContainer>
                        <StyledVideoPlayerInfoContainerHeader>
                            <StyledDivider />
                            <StyledShareWrapper isOpened={showSharePopup}>
                                <Share
                                    videoItem={currentVideoItem}
                                    onEvent={() => {}}
                                />
                            </StyledShareWrapper>
                            <StyledShareIconWrapper
                                isOpened={showSharePopup}
                                onClick={handleShare}
                            >
                                <ShareIcon />
                            </StyledShareIconWrapper>
                        </StyledVideoPlayerInfoContainerHeader>
                        <StyledVideoPlayerHeadline as={withH1 ? 'h1' : 'h2'}>
                            {currentVideoItem.headline}
                        </StyledVideoPlayerHeadline>

                        <SevenVideoDescription
                            description={currentVideoItem.teaser}
                            showMore={isShowMore}
                            showMoreHandler={() =>
                                setIsShowMore((prev) => !prev)
                            }
                        />
                        {product !== Product.SevenNews && (
                            <StyledBylineWrap>
                                <ByLine
                                    profiles={currentVideoItem.profiles}
                                    byline={currentVideoItem.byline}
                                    hasBackground={true}
                                    source={currentVideoItem.source}
                                />
                            </StyledBylineWrap>
                        )}
                    </StyledVideoPlayerInfoContainer>
                    {adElement && (
                        <StyledVideoPlayerAdContainer>
                            {adElement}
                        </StyledVideoPlayerAdContainer>
                    )}
                </StyledVideoInfoAndAdWrapper>
            </Fragment>
        )
    } else {
        return null
    }
}
